<template>
  <base-container>
    <iframe
      style="border:none;position:absolute;top:0;left:0;right:0;bottom:0;"
      height="100%"
      width="100%"
      scrolling="no"
      :src="query.url"
    ></iframe>
  </base-container>
</template>

<script>
export default {
  props:["query"],
  data() {
    return {};
  },
  created() {
    // window.open(
    //   "http://114.55.107.63:8080/webroot/decision/view/form?viewlet=%25E9%25A2%2584%25E7%25BA%25A6%25E6%25BC%2594%25E7%25A4%25BA%25E6%258A%25A5%25E8%25A1%25A8%252F%25E9%25A2%2584%25E7%25BA%25A6%25E6%25A6%2582%25E5%2586%25B5.frm&ref_t=design&ref_c=7b0ab296-17b1-455f-812b-f5b86a79aecc"
    // );
  },
};
</script>

<style>
</style>